function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 9C0 8.44772 0.447715 8 1 8H4C4.55228 8 5 8.44772 5 9V17C5 17.5523 4.55228 18 4 18H1C0.447715 18 0 17.5523 0 17V9Z",
  fill: "#738AA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7 1C7 0.447716 7.44772 0 8 0H11C11.5523 0 12 0.447715 12 1V17C12 17.5523 11.5523 18 11 18H8C7.44772 18 7 17.5523 7 17V1Z",
  fill: "#738AA5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14 4C14 3.44772 14.4477 3 15 3H18C18.5523 3 19 3.44772 19 4V17C19 17.5523 18.5523 18 18 18H15C14.4477 18 14 17.5523 14 17V4Z",
  fill: "#738AA5"
});

function SvgOverviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/OverviewIcon.0f121b46.svg";
export { ForwardRef as ReactComponent };